import { store } from "./index.ts";

/**
 * Stable selector handles for hot paths. These replace `useStore.getState().x` reads
 * inside callbacks/effects that were the playback-machine escape hatches in the old
 * Zustand wiring (App.tsx:137 `tickDelay`, :143 `advance` ranges, :145 active frame,
 * :179 state-jump effect, :255 `applyPxpf` merge). Each handle exposes `.get()` for
 * imperative reads and `.subscribe(observer)` for reactive listeners.
 */
export const selectFps = store.select((c) => c.fps);
